import {
	createCoverOpenAction,
	createCoverCloseAction,
	createCoverStopAction,
	createCoverGoToPositionAction,
	createCoverStateCondition,
	createCoverPositionCondition,
	createCoverStateChangedTrigger,
} from '../../common/rollerControl.js';

/**
 * Dual Roller/Cover Template (Gen2+ RPC API)
 * Supports devices with 2 independent cover/roller channels
 * Uses Cover.Open/Close/Stop/GoToPosition RPC methods
 */
export function createDualRollerTemplate() {
	return {
		deviceType: 'dual_roller',
		channels: ['cover:0', 'cover:1'],
		actions: {
			open: createCoverOpenAction(),
			close: createCoverCloseAction(),
			stop: createCoverStopAction(),
			goToPosition: createCoverGoToPositionAction(),
		},
		conditions: {
			coverState: createCoverStateCondition(),
			coverPosition: createCoverPositionCondition(),
		},
		triggers: {
			stateChanged: createCoverStateChangedTrigger(),
		},
	};
}
